import { render, staticRenderFns } from "./Curriculas.vue?vue&type=template&id=dfbe9226&"
import script from "./Curriculas.vue?vue&type=script&lang=js&"
export * from "./Curriculas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports